import { FootprintMode } from 'utils/footprint-mode';
import { getVisibleFootprintModeToolbarItems } from './footprint-mode-toolbar-items';
import GridModeToolbar from './grid-mode-toolbar';

type FootprintModeToolbarProps = Readonly<{
  mode: FootprintMode;
  onChange: (mode: FootprintMode) => void;
  showImageMode: boolean;
}>;

export default function FootprintModeToolbar({
  mode,
  onChange,
  showImageMode
}: FootprintModeToolbarProps) {
  return (
    <GridModeToolbar
      mode={mode}
      items={getVisibleFootprintModeToolbarItems(showImageMode)}
      idPrefix='footprint-mode'
      onChange={onChange}
    />
  );
}
